/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

/* components */
import Page from "../../shared/Page";
import Phone from "../../ui/Phone";
import Loader from "../../ui/Loader";

/* helpers */
import * as appsActions from "../../../actions/appsActions";

class AppsPage extends Component {
	selectApp = appKey => {
		this.props.history.push("/apps/" + appKey);
	};

	renderApps = () => {
		const { apps } = this.props.apps;
		const { verrisUser } = this.props;
		let showNewAppButton = false;
		if (verrisUser && verrisUser.globalRole === "master") {
			showNewAppButton = true;
		}
		return (
			<div className="app-list">
				{apps && apps.length > 0 ? (
					apps.map(app => {
						return (
							<Phone
								backgroundImage={app.loadingContentUrl ? app.loadingContentUrl : null}
								onSelect={this.selectApp}
								itemKey={app.key}
								key={app.key}
								name={app.name}
							/>
						);
					})
				) : apps ? (
					<div style={{ marginTop: "100px" }}>
						<h3>No Apps Found</h3>
						<div>
							{showNewAppButton
								? "Add An App Above To Get Started"
								: "You haven't been added to any apps yet."}
						</div>
					</div>
				) : (
					<Loader />
				)}
			</div>
		);
	};

	render() {
		const { verrisUser } = this.props;
		let showNewAppButton = false;
		if (verrisUser && verrisUser.globalRole === "master") {
			showNewAppButton = true;
		}
		return (
			<Page title="My Apps">
				<div className="ta-center content-under-header">
					<h3 className="page-title">My Apps</h3>
					{showNewAppButton && (
						<Link to="/apps/add">
							<div className="btn btn-primary grow">+ Add An App</div>
						</Link>
					)}

					{this.renderApps()}
				</div>
			</Page>
		);
	}
}

const mapStateToProps = state => ({
	apps: state.apps,
	user: state.auth.user,
	verrisUser: state.user.user,
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(appsActions, dispatch),
});

AppsPage.propTypes = {
	apps: PropTypes.object,
	actions: PropTypes.object,
	history: PropTypes.object,
	user: PropTypes.object,
	verrisUser: PropTypes.object,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AppsPage);
